var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiobetterLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.2356,
    height: 40,
    fill: "#1D1E2C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0371,
    cy: 25.1308,
    r: 14.8691,
    fill: "#1D1E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiobetterLogoBlue);
export default __webpack_public_path__ + "static/media/biobetter-logo-blue.10ef9f27e05a4405c00275d5a5efff31.svg";
export { ForwardRef as ReactComponent };